export default "__VITE_ASSET__0dfdce82__"